import api from 'services/api/microfwk';
import _ from 'lodash';

export const getContentSerie = (params = {}) =>
  api
    .get('/services/content/serie', {
      params,
    })
    .then(({ data }) => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });
